import { type ReactNode, useId } from "react";
import { styled } from "goober";
import {
  CollapsibleHeader,
  CollapsibleHeaderInner,
  ExpandedContent,
  ExpandedContentHover,
  ExpandInner,
  ExpandWrapper,
} from "./Expand";

const Container = styled("div")`
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 100%;
`;

export function ChatDisclosure({
  header,
  children,
  expanded,
  onToggle,
  disabled = false,
  footer,
  content = "panel",
  keepMounted = false,
}: {
  header: ReactNode;
  children: ReactNode;
  expanded: boolean;
  onToggle: () => void;
  disabled?: boolean;
  footer?: ReactNode;
  content?: "panel" | "plain";
  keepMounted?: boolean;
}) {
  const id = useId();
  const body =
    content === "panel" ? (
      <ExpandedContent>{children}</ExpandedContent>
    ) : (
      children
    );
  return (
    <Container>
      <CollapsibleHeader
        onPress={onToggle}
        disabled={disabled}
        aria-expanded={expanded}
        aria-controls={id}
      >
        <CollapsibleHeaderInner>{header}</CollapsibleHeaderInner>
      </CollapsibleHeader>
      <ExpandWrapper data-expanded={expanded}>
        <ExpandInner
          id={id}
          data-expanded={expanded}
          aria-hidden={!expanded}
          inert={!expanded}
          style={
            content === "plain" && expanded
              ? { overflowY: "visible" }
              : undefined
          }
        >
          {(expanded || keepMounted) &&
            (footer ? (
              <ExpandedContentHover>
                {body}
                {footer}
              </ExpandedContentHover>
            ) : (
              body
            ))}
        </ExpandInner>
      </ExpandWrapper>
    </Container>
  );
}
